const stepperStyles = {
    stepperContainer: {
        width: '100%',
        position: 'sticky',
        paddingTop: '80px',
    },
  }
  
  export default stepperStyles;